import React from 'react';
import './checkbox.css';

const CheckBox = (props) => {
    return (
        <label style = {{ position: 'relative' }} className={props.lblOuter}>
            <input
                type = 'checkbox'
                value = { props.value }
                checked = { props.checked }
                onChange = { (event) => props.handleChange(event, props.index) }
                style = {{ visibility: 'hidden' }}
                name = { props.name }
            />
            { props.showValue }
            <span style = {{
                position: 'absolute',
                left: 0,
                top: '1px',
                width: '20px',
                height: '20px',
                border: '1px solid ' + window.color.searchBoxBgColor,
                background: props.checked ? window.color.searchBoxBgColor : '#fff'
            }} className={props.spanOuter}>
            </span>
            <span style = {{
                position: 'absolute',
                left: '7px',
                top: '2px',
                width: '6px',
                height: '11px',
                border: '1px solid #fff',
                borderWidth: '0 2px 2px 0',
                transform: 'rotate(45deg)',
                zIndex: 2
            }}></span>
        </label>
    );
}

export default CheckBox;


// WEBPACK FOOTER //
// ./src/components/common/checkbox.js